import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Helper } from '../../../helpers/helper';
@Component({
  selector: 'app-vista-mapa',
  templateUrl: './vista-mapa.component.html',
  styleUrls: ['./vista-mapa.component.css']
})
export class VistaMapaComponent implements OnInit {
  zoom = 7;
  lat = 18.6691759;
  lng = -71.2512628;
  @Input() markers: any[];
  @Input() titulo: string;
  urlImg;
  constructor(public activeModal: NgbActiveModal, private helper: Helper) {
    this.urlImg = this.helper.urlImg + 'cedulas/';

  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/vista-mapa/vista-mapa.component.ts